// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// export default function Booking({
// cards = [
//   {
//     title: "Honda Amaze",
//     company: "Shambhu Cabs",
//     seater: "4+1",
//     priceLabel: "Starting ₹999",
//     desc: "Honda Amaze is a compact sedan known for excellent mileage, smooth riding comfort, and perfect suitability for city travel, office commute, and airport transfers.",
//     image: "/images/fleets/amaze.png",
//   },
//   {
//     title: "Toyota Etios",
//     company: "Shambhu Cabs",
//     seater: "4+1",
//     priceLabel: "Starting ₹999",
//     desc: "Toyota Etios is a reliable sedan offering spacious interiors, strong build quality, and smooth performance, making it ideal for local and outstation trips.",
//     image: "/images/fleets/etios.png",
//   },
//   {
//     title: "Hyundai Aura",
//     company: "Shambhu Cabs",
//     seater: "4+1",
//     priceLabel: "Starting ₹1,099",
//     desc: "Hyundai Aura is a premium compact sedan delivering comfort, safety, and a refined driving experience—perfect for corporate and day-to-day travel.",
//     image: "/images/fleets/aura.png",
//   },
//   {
//     title: "Honda City",
//     company: "Shambhu Cabs",
//     seater: "4+1",
//     priceLabel: "Starting ₹1,299",
//     desc: "Honda City is a premium sedan offering outstanding comfort, executive-level ride quality, and best-in-class cabin space—ideal for business and luxury travel.",
//     image: "/images/fleets/honda-city.png",
//   },
//   {
//     title: "Audi A4",
//     company: "Shambhu Cabs",
//     seater: "4+1",
//     priceLabel: "Starting ₹2,499",
//     desc: "Audi A4 is a luxury sedan offering superior comfort, advanced technology, and a premium travel experience suitable for VIP guests and high-end corporate rides.",
//     image: "/images/fleets/audi.png",
//   },

//   // MPV / SUV
//   {
//     title: "Maruti Suzuki Ertiga",
//     company: "Shambhu Cabs",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,499",
//     desc: "Ertiga is a popular 7-seater MPV offering great space, comfort, and excellent mileage—perfect for family tours and long-distance travel.",
//     image: "/images/fleets/ertiga.png",
//   },
//   {
//     title: "Kia Carens",
//     company: "Shambhu Cabs",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,799",
//     desc: "Kia Carens offers premium interiors, advanced safety, and a smooth driving experience—ideal for luxury family travel and group corporate trips.",
//     image: "/images/fleets/kia.png",
//   },
//   {
//     title: "Toyota Innova",
//     company: "Shambhu Cabs",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,899",
//     desc: "Toyota Innova is India’s most trusted MPV known for reliability, spacious cabin, and unmatched long-distance comfort—perfect for outstation rides.",
//     image: "/images/fleets/innova.png",
//   },
//   {
//     title: "Toyota Innova Crysta",
//     company: "Shambhu Cabs",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,999",
//     desc: "Innova Crysta offers premium ride quality, powerful performance, and luxurious interiors—ideal for business trips, airport pickup, and outstation tours.",
//     image: "/images/fleets/innova-crysta.png",
//   },

//   // Traveller / Buses
//   {
//     title: "Tempo Traveller",
//     company: "Shambhu Cabs",
//     seater: "13+1 / 17+1",
//     priceLabel: "Starting ₹3,500",
//     desc: "Tempo Traveller is perfect for group travel, picnics, office team outings, and long-distance family tours with spacious seating and comfortable interiors.",
//     image: "/images/fleets/tempo-traveller.png",
//   },
//   {
//     title: "Mini Bus",
//     company: "Shambhu Cabs",
//     seater: "20+1 / 26+1",
//     priceLabel: "Starting ₹5,999",
//     desc: "Mini Bus offers excellent comfort for medium-sized groups, suitable for corporate events, weddings, school trips, and outstation group travel.",
//     image: "/images/fleets/mini-bus.png",
//   },
//   {
//     title: "Luxury AC Bus",
//     company: "Shambhu Cabs",
//     seater: "32+1 / 45+1",
//     priceLabel: "Starting ₹8,999",
//     desc: "Luxury AC Bus is ideal for large group travel, corporate tours, pilgrimage trips, and weddings, providing spacious seating and smooth long-distance travel.",
//     image: "/images/fleets/bus.png",
//   },
// ],
// }) {
//   const handleWhatsAppBooking = (title) => {
//     const phone = "919819399797";
//     const message = `Hello Shambhu Cabs, I want to book ${title}. Please share more details.`;
//     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <>
//   <section className="gauto-breadcromb-area section_70">
//               <div className="container">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="breadcromb-box">
//                       <h3>Booking</h3>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </section>
        

//       {/* ===== Booking Cards ===== */}
//       <section
//         className="taxi-rates-page section-space"
//         style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
//       >
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {cards.map((c, idx) => (
//               <div className="col-xl-4 col-md-6 d-flex" key={idx}>
//                 <div
//                   className="taxi-card d-flex flex-column"
//                   style={{
//                     width: "100%",
//                     backgroundColor: "#fff",
//                     borderRadius: "12px",
//                     overflow: "hidden",
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//                     transition: "transform 0.3s ease",
//                     height: "100%",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.transform = "translateY(-6px)")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.transform = "translateY(0)")
//                   }
//                 >
//                   {/* Image */}
//                   <div
//                     style={{
//                       backgroundColor: "#542E90",
//                       padding: "20px",
//                       textAlign: "center",
//                     }}
//                   >
//                     <img
//                       src={c.image}
//                       alt={c.title}
//                       loading="lazy"
//                       style={{
//                         width: "100%",
//                         maxHeight: "220px",
//                         objectFit: "contain",
//                         borderRadius: "8px",
//                       }}
//                     />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       backgroundColor: "#000",
//                       color: "#fff",
//                       padding: "25px 20px",
//                       flex: "1",
//                     }}
//                     className="d-flex flex-column justify-content-between"
//                   >
//                     <div>
//                       <h3 className="text-center mb-2">{c.title}</h3>
//                       <p
//                         className="text-center mb-4"
//                         style={{ color: "#b0b0b0", fontSize: "0.9rem" }}
//                       >
//                         {c.company}
//                       </p>

//                       {/* ⭐ Seater Row */}
//                       <ul
//                         className="list-unstyled"
//                         style={{
//                           margin: "0 auto 25px auto",
//                           textAlign: "center",
//                           color: "#fff",
//                           fontSize: "1.05rem",
//                           width: "80%",
//                           fontWeight: 600,
//                         }}
//                       >
//                         <li className="d-flex justify-content-center">
//                           Seater: ({c.seater})
//                         </li>
//                       </ul>
//                     </div>

//                     {/* Book Now */}
//                     <div className="text-center mt-auto">
//                       <button
//                         onClick={() => handleWhatsAppBooking(c.title)}
//                         style={{
//                           backgroundColor: "#542E90",
//                           color: "#fff",
//                           borderRadius: "6px",
//                           padding: "10px 24px",
//                           fontWeight: 600,
//                           gap: "8px",
//                           width: "60%",
//                           border: "none",
//                           cursor: "pointer",
//                           transition: "background 0.3s ease",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.background = "#542E90")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.background = "#542E90")
//                         }
//                         className="btn d-inline-flex align-items-center justify-content-center"
//                       >
//                         <i className="fab fa-whatsapp" /> Book Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }









import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Booking({
  cards = [
  {
    title: "Honda Amaze",
    company: "Shambhu Cabs",
    seater: "4+1",
    priceLabel: "Starting ₹999",
    desc: "Honda Amaze is a compact sedan known for excellent mileage, smooth riding comfort, and perfect suitability for city travel, office commute, and airport transfers.",
    image: "/images/fleets/amaze.png",
  },
  {
    title: "Toyota Etios",
    company: "Shambhu Cabs",
    seater: "4+1",
    priceLabel: "Starting ₹999",
    desc: "Toyota Etios is a reliable sedan offering spacious interiors, strong build quality, and smooth performance, making it ideal for local and outstation trips.",
    image: "/images/fleets/etios.png",
  },
  {
    title: "Hyundai Aura",
    company: "Shambhu Cabs",
    seater: "4+1",
    priceLabel: "Starting ₹1,099",
    desc: "Hyundai Aura is a premium compact sedan delivering comfort, safety, and a refined driving experience—perfect for corporate and day-to-day travel.",
    image: "/images/fleets/aura.png",
  },
  {
    title: "Honda City",
    company: "Shambhu Cabs",
    seater: "4+1",
    priceLabel: "Starting ₹1,299",
    desc: "Honda City is a premium sedan offering outstanding comfort, executive-level ride quality, and best-in-class cabin space—ideal for business and luxury travel.",
    image: "/images/fleets/honda-city.png",
  },
  {
    title: "Audi A4",
    company: "Shambhu Cabs",
    seater: "4+1",
    priceLabel: "Starting ₹2,499",
    desc: "Audi A4 is a luxury sedan offering superior comfort, advanced technology, and a premium travel experience suitable for VIP guests and high-end corporate rides.",
    image: "/images/fleets/audi.png",
  },

  // MPV / SUV
  {
    title: "Maruti Suzuki Ertiga",
    company: "Shambhu Cabs",
    seater: "7+1",
    priceLabel: "Starting ₹1,499",
    desc: "Ertiga is a popular 7-seater MPV offering great space, comfort, and excellent mileage—perfect for family tours and long-distance travel.",
    image: "/images/fleets/ertiga.png",
  },
  {
    title: "Kia Carens",
    company: "Shambhu Cabs",
    seater: "7+1",
    priceLabel: "Starting ₹1,799",
    desc: "Kia Carens offers premium interiors, advanced safety, and a smooth driving experience—ideal for luxury family travel and group corporate trips.",
    image: "/images/fleets/kia.png",
  },
  {
    title: "Toyota Innova",
    company: "Shambhu Cabs",
    seater: "7+1",
    priceLabel: "Starting ₹1,899",
    desc: "Toyota Innova is India’s most trusted MPV known for reliability, spacious cabin, and unmatched long-distance comfort—perfect for outstation rides.",
    image: "/images/fleets/innova.png",
  },
  {
    title: "Toyota Innova Crysta",
    company: "Shambhu Cabs",
    seater: "7+1",
    priceLabel: "Starting ₹1,999",
    desc: "Innova Crysta offers premium ride quality, powerful performance, and luxurious interiors—ideal for business trips, airport pickup, and outstation tours.",
    image: "/images/fleets/innova-crysta.png",
  },

  // Traveller / Buses
  {
    title: "Tempo Traveller",
    company: "Shambhu Cabs",
    seater: "13+1 / 17+1",
    priceLabel: "Starting ₹3,500",
    desc: "Tempo Traveller is perfect for group travel, picnics, office team outings, and long-distance family tours with spacious seating and comfortable interiors.",
    image: "/images/fleets/tempo-traveller.png",
  },
  {
    title: "Mini Bus",
    company: "Shambhu Cabs",
    seater: "20+1 / 26+1",
    priceLabel: "Starting ₹5,999",
    desc: "Mini Bus offers excellent comfort for medium-sized groups, suitable for corporate events, weddings, school trips, and outstation group travel.",
    image: "/images/fleets/mini-bus.png",
  },
  {
    title: "Luxury AC Bus",
    company: "Shambhu Cabs",
    seater: "32+1 / 45+1",
    priceLabel: "Starting ₹8,999",
    desc: "Luxury AC Bus is ideal for large group travel, corporate tours, pilgrimage trips, and weddings, providing spacious seating and smooth long-distance travel.",
    image: "/images/fleets/bus.png",
  },
],
}) {
  const handleWhatsAppBooking = (title) => {
    const phone = "919819399797";
    const msg = `Hello Shambhu Cabs, I want to book ${title}.`;
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* BREADCRUMB */}
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <h3 className="text-center text-white">Booking</h3>
        </div>
      </section>

      {/* CARDS */}
      <section style={{ background: "#f5f7fb", padding: "70px 0" }}>
        <div className="container">
          <div className="row g-4">
            {cards.map((c, i) => (
              <div className="col-xl-4 col-md-6" key={i}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "14px",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    height: "100%",
                    transition: "0.3s",
                  }}
                  className="h-100"
                >
                  {/* IMAGE */}
                  <div
                    style={{
                      background: "#4b2d87",
                      padding: "25px",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={c.image}
                      alt={c.title}
                      style={{
                        maxHeight: "200px",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* CONTENT */}
                  <div style={{ padding: "25px" }}>
                    <h4
                      style={{
                        color: "#2c2c2c",
                        fontWeight: 700,
                        textAlign: "center",
                      }}
                    >
                      {c.title}
                    </h4>

                    <p
                      style={{
                        textAlign: "center",
                        color: "#7a7a7a",
                        fontSize: "14px",
                        marginBottom: "18px",
                      }}
                    >
                      {c.company}
                    </p>

                    {/* ICON ROW */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "18px",
                        marginBottom: "22px",
                        color: "#4b2d87",
                        fontWeight: 600,
                      }}
                    >
                      <span>
                        <i className="fas fa-user-friends me-2"></i>
                        {c.seater}
                      </span>
                    </div>

                    {/* BUTTON */}
                    <div className="text-center">
                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        style={{
                          background: "#4b2d87",
                          color: "#fff",
                          border: "none",
                          padding: "11px 26px",
                          borderRadius: "6px",
                          fontWeight: 600,
                          width: "70%",
                        }}
                      >
                        <i className="fab fa-whatsapp me-2"></i>
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}